export default __webpack_public_path__ + "static/media/user-feelings.607cedf1.svg";